import { render, staticRenderFns } from "./KolonneSettingsCrud.vue?vue&type=template&id=cf75c09c"
import script from "./KolonneSettingsCrud.vue?vue&type=script&lang=js"
export * from "./KolonneSettingsCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports